import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Icon from '../../icon/';

import './style.scss';

const Indicator = ({ type, size, paddingSpace }) => {
  const typeClasses = classNames('uni-indicator', {
    'uni-indicator--information': type === 'information',
    'uni-indicator--warning': type === 'warning',
    'uni-indicator--critical': type === 'critical',
    'uni-indicator--confirmation': type === 'confirmation',
    'uni-indicator--success': type === 'success',
    [`uni-pad--${paddingSpace}`]: paddingSpace,
  });

  if (type === 'success') {
    giveWarning(
      'The success prop value is deprecated and will be removed in the next major ' +
        'release of uniform-ui-components. Use the confirmation prop value instead.'
    );
  }

  return (
    <div className={typeClasses}>
      <Icon size={size} type={type === 'success' ? 'confirmation' : type} />
    </div>
  );
};

Indicator.propTypes = {
  type: PropTypes.oneOf(['information', 'warning', 'critical', 'confirmation', 'success']).isRequired,
  size: PropTypes.oneOf(['medium', 'large']),
  paddingSpace: PropTypes.string,
};

export default Indicator;



// WEBPACK FOOTER //
// ./src/notifications/__partials/indicator.jsx